import { PremiumFeature } from 'gleblu-socket-api';
import { createAction } from 'redux-act';

import { Price } from '../../../models/interfaces/Price';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchPricesPayload extends FetchPayload {
  feature: PremiumFeature;
  placeUuid: string;
}
export const fetchPrices = createAction<FetchPricesPayload>('FETCH_PRICES');

export interface PricesFetchedPayload extends TimestampPayload {
  prices: Price[];
  feature: PremiumFeature;
  placeUuid: string;
}
export const pricesFetched = createAction<PricesFetchedPayload>('PRICES_FETCHED');

export interface PricesFetchFailedPayload extends TimestampPayload {
  feature: PremiumFeature;
  placeUuid: string;
}
export const pricesFetchFailed = createAction<PricesFetchFailedPayload>('PRICES_FETCH_FAILED');
